export default "__VITE_ASSET__CL7gJsPD__"